"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class is used for transforming data from IRW into the format of the Store model.
 */
var IowsStoreTransformer = /** @class */ (function () {
    function IowsStoreTransformer() {
    }
    /**
     * Transforms data into format of StoreAvailability model.
     *
     * @param data Data to parse.
     * @returns Parsed data.
     */
    IowsStoreTransformer.prototype.transform = function (data) {
        var stores = [];
        if (data['StoreRefList'] && data['StoreRefList'].StoreRef) {
            var items = Array.isArray(data['StoreRefList'].StoreRef)
                ? data['StoreRefList'].StoreRef
                : [data['StoreRefList'].StoreRef];
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                stores.push({
                    location: this.getLocation(item),
                    name: item.StoreName && item.StoreName.$ ? item.StoreName.$ : null,
                    id: item.StoreNo && item.StoreNo.$ ? String(item.StoreNo.$) : null,
                    url: item.StoreUrl && item.StoreUrl.$ ? item.StoreUrl.$ : null
                });
            }
        }
        return stores;
    };
    /**
     * Returns location.
     *
     * @param item Store item.
     * @returns Parsed data.
     */
    IowsStoreTransformer.prototype.getLocation = function (item) {
        if (item['StoreLocation'] &&
            item['StoreLocation'].Latitude &&
            item['StoreLocation'].Latitude.$) {
            return {
                latitude: item['StoreLocation'].Latitude.$,
                longitude: item['StoreLocation'].Longitude.$
            };
        }
        return null;
    };
    return IowsStoreTransformer;
}());
exports.default = IowsStoreTransformer;
//# sourceMappingURL=IowsStoreTransformer.js.map